import axios from "axios";
import queryString from "query-string";

export default function shareRecipe({ signal }) {
  const source = axios.CancelToken.source();

  if (signal) {
    signal.addEventListener("abort", () => {
      source.cancel();
    });
  }

  return ({
    recipeID,
    value,
    final_image,
    userChoiceValuesForUI,
    expectedDelivery,
    cost,
    selectedProduct,
    id,
    locale,
  }) => {
    const { origin, hash, search, pathname } = window.location;
    const queryParams = {
      ...queryString.parse(search),
      recipeID,
    };
    const url =
      origin + pathname + "?" + queryString.stringify(queryParams) + hash;

    return axios({
      url: process.env.REACT_APP_SHARE_RECIPE_URL,
      method: "POST",
      cancelToken: source.token,
      headers: {
        Accept: "text/html",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: new URLSearchParams({
        data: JSON.stringify({
          token: process.env.REACT_APP_KLAVIYO_PUBLIC_KEY,
          event: "Share MyBauer",
          customer_properties: {
            $email: value,
          },
          properties: {
            value: cost,
            message: url,
            finalImage: final_image,
            userChoices: userChoiceValuesForUI,
            expectedDelivery,
            selectedProductName: selectedProduct.name,
            productID: id,
            locale,
          },
        }),
      }),
    });
  };
}
